import "./App.css";
import Dictionary from "./Dictionary";

function App() {
  return (
    <div className="App">
      <Dictionary />
      <footer>
        {/* Codded by Anastasiia Semenova. Available on{" "}
        <a
          href="https://github.com/AnastasiiaSemenovaa/react-dictionary"
          target="_blank"
          rel="noreferrer"
        >
          GitHub
        </a>{" "} */}
      </footer>
    </div>
  );
}

export default App;
